import React from 'react';

interface EmptyDataViewProps {
  message: string;
}

const EmptyDataView: React.FC<EmptyDataViewProps> = ({ message }) => {
  return (
    <div
      style={{
        color: '#8e8e8e',
        height: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {message}
    </div>
  );
};

export default EmptyDataView;
